@if (selectedItemIsMachine) {
  <app-machine-detail-sidebar></app-machine-detail-sidebar>
} @else if (selectedItemIsPlanningItem) {
  <app-planning-item-sidebar vdwDelayedClass="blurry-content-fix"></app-planning-item-sidebar>
} @else if (showOrdersToPlan) {
  <app-to-plan></app-to-plan>
} @else if (showFixedSchedulesToPlan) {
  <app-fixed-schedules-sidebar></app-fixed-schedules-sidebar>
}
